import linkifyStr from 'linkify-string'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('linkify', {
    mounted(el, binding) {
      el.innerHTML = linkifyStr(binding.value, { target: '_blank', nl2br: true })
    }
  })
})
